class BobcutCatalogSidebar extends HTMLElement {
  connectedCallback() {
    this.disclosure = this.querySelector('[data-catalog-disclosure]');
    if (!this.disclosure) return;
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.mobileOpen = false;
    this.syncBreakpoint = () => {
      this.disclosure.open = this.desktopQuery.matches || this.mobileOpen;
    };
    this.trackMobileState = () => {
      if (!this.desktopQuery.matches) this.mobileOpen = this.disclosure.open;
    };
    this.syncBreakpoint();
    this.desktopQuery.addEventListener('change', this.syncBreakpoint);
    this.disclosure.addEventListener('toggle', this.trackMobileState);
  }

  disconnectedCallback() {
    this.desktopQuery?.removeEventListener('change', this.syncBreakpoint);
    this.disclosure?.removeEventListener('toggle', this.trackMobileState);
  }
}

if (!customElements.get('bobcut-catalog-sidebar')) {
  customElements.define('bobcut-catalog-sidebar', BobcutCatalogSidebar);
}
